import { t } from "i18next";

export enum SystemRole {
    Administrator = 'Administrator',
    Student = 'Student'
}

export const getSystemRoleLabels = () => ({
    [SystemRole.Administrator]: t('role.roleLabels.administrator'),
    [SystemRole.Student]: t('role.roleLabels.student'),
});

export const getSystemRoleLabel = (role: SystemRole): string => {
    const labels = getSystemRoleLabels();
    return labels[role];
};
